'use strict';

export const notifyCount = "";
export const version: string="22.2.2";   
export const isOverdraftAvailable:boolean = false;

export class GlobalConstants {  
    isOverdraftAvailable:boolean = false;
 } 